const theme = {
  config: {
    useSystemColorMode: false,
    initialColorMode: "dark",
  },
  colors: {
    red: {
      100: "#ED1D24",
      200: "#ED1D24",
      300: "#c21808",
      400: "#c21808",
      500: "#ae1508",
      600: "#9b1205",
      700: "#9b1205",
      800: "#740e05",
      900: "#740e05",
    },
    blue: {
      100: "#ED1D24",
      200: "#ED1D24",
      300: "#c21808",
      400: "#c21808",
      500: "#ae1508",
      600: "#9b1205",
      700: "#9b1205",
      800: "#740e05",
      900: "#740e05",
    },
    gray: {
      700: "#222b45",
    },
  },
  buttons: {
    primary: {
      color: "#fff",
    },
  },
};

export default theme;
